import PropTypes from 'prop-types';
import { getBuyButton, getBuyText, getBuyIcon, BUY_TYPES } from './FeedHelper';

export default function FeedPostBuyOverlay({ actor, postId, price, type }) {
	return (
		<div className={'feed__need-buy'}>
			{getBuyIcon(type, BUY_TYPES.PC)}
			{getBuyText(actor.name, 'feed.need-buy-text--')}
			{getBuyButton({ postId, price: price, actorId: parseInt(actor.id) })}
		</div>
	);
}

FeedPostBuyOverlay.propTypes = {
	actor: PropTypes.object.isRequired,
	postId: PropTypes.number.isRequired,
	type: PropTypes.string.isRequired,
	price: PropTypes.number.isRequired,
};
